export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13880.a046d060.jpg";